module.exports = __webpack_public_path__ + "static/mobile-banner-no-user-4fb8ee15cfe2239f9db0405d404eeff5.svg";